import React from 'react';
import Navbar from '../Layout/Navbar';
import Footer from '../Layout/Footer';
import { Outlet } from 'react-router-dom';

const Layout = ({ darkMode, toggleDarkMode }) => (
  <div className={`min-h-screen transition-colors duration-300 ${darkMode ? 'dark bg-dark-900' : 'bg-gray-50'}`}>
    <div className="flex flex-col min-h-screen">
      <Navbar darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  </div>
);

export default Layout;
